import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SectionWrapper from '../../CardRow/SectionWrapper';
import DetailWrapper from '../../CardRow/DetailWrapper';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import ButtonWrapper from '../../Button/ButtonWrapper';
import DefaultButton from '../../Button/DefaultButton';
import { useForm } from 'react-hook-form';
import CustomNumberFormat from '../../CustomizedComponents/CustomNumberFormat';
import { useIntl } from 'react-intl';

const Buttons = ({ editable, cancel, handleChange, isNew, continueTitle, save, postLoading, putLoading }) => {
  return (
    <ButtonWrapper>
      <DefaultButton
        id={'cancel'}
        primary={false}
        disabled={!editable}
        title={cancel}
        onClick={(event) => {
          handleChange(event.currentTarget.id);
        }}
      />
      <DefaultButton primary={true} disabled={!editable} type="submit" title={isNew ? continueTitle : save} loaders={[postLoading, putLoading]} />
    </ButtonWrapper>
  );
};

Buttons.propTypes = {
  editable: PropTypes.bool,
  cancel: PropTypes.string,
  handleChange: PropTypes.func,
  isNew: PropTypes.bool,
  continueTitle: PropTypes.string,
  save: PropTypes.string,
  postLoading: PropTypes.bool,
  putLoading: PropTypes.bool,
};

const PurchaseStep = ({ transaction, handlers, enums, editable, setEditable, isNew, handler, idPanel, setOpen }) => {
  const {
    exchangeProductEnum,
    productId,
    purchaseTypesId,
    priceSourceId,
    currencyId,
    transactionTypeId,
    rate,
    price,
    period,
    quantity,
    postLoading,
    putLoading,
  } = transaction;

  const { setPurchaseTypesId, setProductId, setPriceSourceId, setTransactionTypeId, setRate, setPrice, setQuantity, sendHandler } = handlers;
  const { handleSubmit, register, errors } = useForm();
  const [currency, setCurrency] = useState('');
  const intl = useIntl();
  const productTitle = 'app.transaction.product';
  const typeTransactionTitle = 'app.transaction.typeTransaction';
  const typePriceTitle = 'app.transaction.typePrice';
  const transactionTypeTitle = 'app.transaction.transactionType';
  const currencyTitle = 'app.transaction.currency';
  const rateTitle = 'app.transaction.rate';
  const priceTitle = 'app.transaction.price.mwh';
  const periodTitle = 'app.contract.period';
  const cancel = 'app.buttons.cancel';
  const save = 'app.buttons.save';
  const continueTitle = 'app.buttons.continue';
  const quantityTitle = 'app.transaction.volumeMWh';
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const dataIncorrect = intl.formatMessage({ id: 'app.data.incorrect' });

  const handleChange = (idButton) => {
    if (!isNew) {
      setEditable(!editable);
      if (idButton !== 'cancel') {
        setOpen(true);
        sendHandler();
      }
    } else {
      handler(idPanel, true);
    }
  };

  useEffect(() => {
    if (currencyId) {
      setCurrency(() => {
        return enums?.currencies.find((item) => item.id === currencyId)?.name;
      });
    }
  }, [currencyId, enums, setCurrency]);

  return (
    <>
      <DetailWrapper>
        <SectionWrapper>
          <form onSubmit={handleSubmit(handleChange)}>
            <CustomTextField
              id="1"
              name={'productId'}
              onChange={(event) => {
                setProductId(event.target.value);
              }}
              select
              title={productTitle}
              value={productId}
              disabled={!editable}
              variant="outlined"
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.productId?.message}
              error={!!errors?.productId}>
              <option value={null} />
              {getOptions(exchangeProductEnum)}
            </CustomTextField>
            <CustomTextField
              id="2"
              name={'purchaseTypesId'}
              onChange={(event) => {
                setPurchaseTypesId(event.target.value);
              }}
              select
              title={typeTransactionTitle}
              value={purchaseTypesId}
              disabled={!editable}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.purchaseTypesId?.message}
              error={!!errors?.purchaseTypesId}>
              <option value={null} />
              {getOptions(enums.purchaseTypes)}
            </CustomTextField>
            <CustomTextField
              id="3"
              name={'priceSourceId'}
              onChange={(event) => {
                setPriceSourceId(event.target.value);
              }}
              select
              title={typePriceTitle}
              value={priceSourceId}
              disabled={!editable}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.priceSourceId?.message}
              error={!!errors?.priceSourceId}>
              <option value={null} />
              {getOptions(enums.priceSources)}
            </CustomTextField>
            <CustomTextField
              id="4"
              name={'transactionTypeId'}
              onChange={(event) => {
                setTransactionTypeId(event.target.value);
              }}
              select
              title={transactionTypeTitle}
              value={transactionTypeId}
              disabled={!editable}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.transactionTypeId?.message}
              error={!!errors?.transactionTypeId}>
              <option value={null} />
              {getOptions(enums.transactionTypes)}
            </CustomTextField>
            <PurchaseStepDetailTextFields
              currency={currency}
              currencyTitle={currencyTitle}
              rate={rate}
              setRate={setRate}
              rateTitle={rateTitle}
              price={price}
              setPrice={setPrice}
              priceTitle={priceTitle}
              period={period}
              periodTitle={periodTitle}
              errors={errors}
              register={register}
              dataIncorrect={dataIncorrect}
              dataMissing={dataMissing}
              editable={editable}
              setQuantity={setQuantity}
              quantity={quantity}
              quantityTitle={quantityTitle}
            />
            <ButtonWrapper>
              <Buttons
                cancel={cancel}
                continueTitle={continueTitle}
                editable={editable}
                handleChange={handleChange}
                isNew={isNew}
                postLoading={postLoading}
                putLoading={putLoading}
                save={save}
              />
            </ButtonWrapper>
          </form>
        </SectionWrapper>
      </DetailWrapper>
    </>
  );
};

PurchaseStep.propTypes = {
  transaction: PropTypes.object,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  enums: PropTypes.object,
  isNew: PropTypes.bool,
  register: PropTypes.any,
  errors: PropTypes.object,
  setEditable: PropTypes.func,
  handler: PropTypes.func,
  idPanel: PropTypes.any,
  setOpen: PropTypes.func,
};
const getOptions = (option) => {
  return option.map((item) => (
    <option key={item.id} value={item.id}>
      {item.name}
    </option>
  ));
};

const PurchaseStepDetailTextFields = ({
  currency,
  currencyTitle,
  rate,
  setRate,
  rateTitle,
  editable,
  price,
  setPrice,
  priceTitle,
  period,
  periodTitle,
  register,
  dataMissing,
  errors,
  setQuantity,
  quantity,
  quantityTitle,
}) => {
  const fields = [
    {
      id: '1',
      name: 'quantity',
      onChange: (event) => {
        setQuantity(event.target.value);
      },
      title: quantityTitle,
      disabled: !editable,
      value: quantity.toLocaleString('cs-CZ', {
        maximumFractionDigits: 3,
      }),
      variant: 'outlined',
      InputProps: {
        inputComponent: CustomNumberFormat,
      },
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.quantity?.message,
      error: !!errors?.quantity,
    },
    {
      id: '2',
      name: 'period',
      title: periodTitle,
      value: period,
      disabled: true,
      variant: 'outlined',
    },
    {
      id: '3',
      name: 'currency',
      title: currencyTitle,
      value: currency,
      disabled: true,
      variant: 'outlined',
    },
    {
      id: '4',
      name: 'rate',
      onChange: (event) => {
        setRate(event.target.value);
      },
      title: rateTitle,
      disabled: !editable,
      InputProps: {
        inputComponent: CustomNumberFormat,
      },
      value: rate.toLocaleString('cs-CZ', {
        maximumFractionDigits: 3,
      }),
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.rate?.message,
      error: !!errors?.rate,
    },
    {
      id: '5',
      name: 'price',
      onChange: (event) => {
        setPrice(event.target.value);
      },
      disabled: !editable,
      InputProps: {
        inputComponent: CustomNumberFormat,
      },
      title: priceTitle,
      value: price.toLocaleString('cs-CZ', {
        maximumFractionDigits: 3,
      }),
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.price?.message,
      error: !!errors?.price,
    },
  ];

  return (
    <>
      {fields.map((field) => (
        <CustomTextField key={field.id} {...field} />
      ))}
    </>
  );
};

PurchaseStepDetailTextFields.propTypes = {
  currency: PropTypes.any,
  currencyTitle: PropTypes.any,
  rate: PropTypes.any,
  setRate: PropTypes.any,
  rateTitle: PropTypes.any,
  price: PropTypes.any,
  setPrice: PropTypes.any,
  priceTitle: PropTypes.any,
  period: PropTypes.any,
  periodTitle: PropTypes.any,
  register: PropTypes.any,
  dataMissing: PropTypes.any,
  errors: PropTypes.any,
  editable: PropTypes.any,
  setQuantity: PropTypes.any,
  quantity: PropTypes.any,
  quantityTitle: PropTypes.any,
};

export default PurchaseStep;
